import { render, staticRenderFns } from "./StatBlock.vue?vue&type=template&id=a0b38578&scoped=true&"
import script from "./StatBlock.vue?vue&type=script&lang=js&"
export * from "./StatBlock.vue?vue&type=script&lang=js&"
import style0 from "./StatBlock.vue?vue&type=style&index=0&id=a0b38578&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0b38578",
  null
  
)

export default component.exports